import { Component } from "react";
import { connect } from "react-redux";
import { getEndOfDay, getClockString, getCurrentDate } from "../time";
import Typography from "@mui/material/Typography";

class DrawDay extends Component {
    //appel au planning pour l'ouverture de la page de modification
    openModificationPanel(imputation) {
        if (!imputation.in_progress && this.props.day && !this.props.day.validation && this.props.modifiable) {
            this.props.modification(imputation);
        }
    }

    endOfDay() {
        if (this.props.imputations.length > 0 && this.props.day) {
            let last_item = this.props.imputations[this.props.imputations.length - 1];
            if (
                last_item &&
                last_item.activity &&
                (last_item.activity.home ||
                    (!last_item.in_progress && last_item.date_end >= getEndOfDay(this.props.day.date)))
            ) {
                return {
                    background: "red",
                    height: 3,
                    width: "100%",
                    marginTop: this.DateToPx(last_item.date_end),
                    position: "absolute",
                };
            }
        }
        return {};
    }

    render() {
        return (
            <div id="container_planning" style={this.props.style}>
                <div className="no_margin index_time_planning" id="index_planning">
                    <div style={this.endOfDay()} />
                    {this.getTimeList()}
                </div>
                <div className="content_time_planning" id="content_planning">
                    {this.props.day && (
                        <div>
                            {this.props.imputations.map((item) => {
                                if (item !== undefined && item.activity !== undefined) {
                                    return (
                                        <div
                                            className="item"
                                            style={this.GetStyle(item)}
                                            key={item.id}
                                            onClick={this.openModificationPanel.bind(this, item)}
                                        >
                                            <div style={{ marginLeft: 5 }}>
                                                <Typography
                                                    style={{
                                                        color: this.oppositeColor(item.activity.color, true),
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {item.activity.name +
                                                        (item.business !== "" ? " : " + item.business : item.business) +
                                                        (item.commentary !== ""
                                                            ? " - " + item.commentary
                                                            : item.commentary)}
                                                </Typography>
                                                {item.work_order_detail !== undefined ? (
                                                    <div style={{ paddingTop: 0, marginTop: 0 }}>
                                                        <p
                                                            style={{
                                                                paddingTop: 0,
                                                                marginTop: 0,
                                                                paddingBottom: 0,
                                                                marginBottom: 2,
                                                                fontSize: 10,
                                                                color: "#333333",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            {item.work_order_detail.customer}
                                                        </p>
                                                        <p
                                                            style={{
                                                                paddingTop: 0,
                                                                marginTop: 0,
                                                                paddingBottom: 0,
                                                                marginBottom: 2,
                                                                fontSize: 10,
                                                                color: "#333333",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            {item.work_order_detail.description}
                                                        </p>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    );
                                } else return null;
                            })}
                            {this.props.imputations.map((item) =>
                                item.in_progress ? (
                                    <div style={this.GetStyleArrow()} key={item.id + "arrow"}>
                                        <svg viewBox="0 0 100 20" preserveAspectRatio="xMinYMin meet">
                                            <path
                                                fill={item.activity.color}
                                                stroke={item.activity.color}
                                                d="M 45 0 L 55 0 L 55 3 L 60 3 L 50 10 L 40 3 L 45 3 Z"
                                            />
                                        </svg>
                                    </div>
                                ) : null
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    GetStyle(imputation) {
        let end = imputation.in_progress ? getCurrentDate() : imputation.date_end;
        let px_start = this.DateToPx(imputation.date_start);
        let px_end = this.DateToPx(end);
        let height = px_end - px_start;
        return {
            marginTop: px_start,
            height: height,
            background: imputation.activity.color,
            width: "95%",
            color: this.oppositeColor(imputation.activity.color, true),
            cursor:
                !imputation.in_progress && this.props.day && !this.props.day.validation && this.props.modifiable
                    ? "pointer"
                    : undefined,
            overflow: "hidden",
            border: "1px",
            borderStyle: "solid",
            borderColor: "#FFFFFF",
        };
    }

    GetStyleArrow() {
        return {
            width: "100%",
            position: "absolute",
            marginTop: this.DateToPx(getCurrentDate()) - 1 + "px",
            display: "inline-block",
        };
    }

    //convertion des données de date en coordonées verticales de pixels pour le dessin dans le canvas
    DateToPx(date) {
        let ratio = 1176 / 24.5;
        let hour = getClockString(date);
        let tab = hour.split(":");
        let h = tab[0];
        let m = tab[1];
        let s = tab.length > 2 ? tab[2] : 0;
        return h * ratio + (m * ratio) / 60 + (s * ratio) / 3600 + (15 * ratio) / 60;
    }

    //récupération des horraires à afficher sur la gauche du planning
    getTimeList() {
        let list = [];
        for (let i = 0; i <= 240; i = i + 5) {
            let data = (i % 240 < 100 ? "0" : "") + Math.floor((i % 240) / 10) + ":" + (i % 10 === 5 ? "30" : "00");
            list.push(
                <div className="hour_text no_margin" key={i} style={{ color: "#005bba" }}>
                    {data}
                </div>
            );
        }
        return list;
    }

    //récupération de la couleur du texte à afficher pour être en contraste avec la couleur de l'imputation
    oppositeColor(color, w_b) {
        if (color.indexOf("#") === 0) {
            color = color.slice(1);
        }

        if (color.length === 3) {
            color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
        }
        if (color.length !== 6) {
            throw new Error("Invalid HEX color.");
        }
        let r = parseInt(color.slice(0, 2), 16),
            g = parseInt(color.slice(2, 4), 16),
            b = parseInt(color.slice(4, 6), 16);

        if (w_b) {
            return r * 0.299 + g * 0.587 + b * 0.114 > 148 ? "#000000" : "#FFFFFF";
        } else {
            r = (255 - r).toString(16);
            g = (255 - g).toString(16);
            b = (255 - b).toString(16);

            return "#" + this.padZero(r) + this.padZero(g) + this.padZero(b);
        }
    }

    //ajout d'un 0 pour avoir toujours deux caractères sur les valeurs hexadécimales
    padZero(str, len) {
        len = len || 2;
        let zeros = new Array(len).join("0");
        return (zeros + str).slice(-len);
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        imputations: state.activeDayImputations,
    };
};
const mapDispatchToProps = () => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawDay);
